import React, { FC } from 'react';

import { Button } from '@/shared/components/Button/Button';
import { RouterLink } from '@/shared/components/RouterLink/RouterLink';
import { mainRoute } from '@/scenarios/home/routes';

import { useI18n } from '../../hooks/useI18n';

import styles from './ExploreButton.module.css';
import { ExploreButtonConfig } from './config';

interface ExploreButtonProps {
    className?: string;
}

export const ExploreButton: FC<ExploreButtonProps> = ({ className }) => {
    const i18n = useI18n();

    return (
        <RouterLink to={mainRoute()} className={styles.link}>
            <Button
                className={className}
                variant={ExploreButtonConfig.buttonType}
                size={60}
                theme="dark"
                data-test-id="ContentActions_exploreButton"
            >
                {i18n('content_actions__explore_text')}
            </Button>
        </RouterLink>
    );
};
